import { OrderTagsFilter, statusesMap, useOrderFilter } from 'entities/orders';
import { OrderGuestsFilter } from 'entities/orders/ui/orderFilters/components/orderGuestsFilter';
import { selectOrderTagsNames } from 'entities/tags';
import { FilterManager } from 'features/filterManager';
import { TNameMapValue } from 'shared/lib/pagination';
import { useAppSelector } from 'shared/lib/store';
import { ModalProvider } from 'shared/ui/modal';
import { FilterCard } from 'shared/ui/pagination/ui/filterCard';

export const WaitingOrdersFilterPanel = () => {
	const {
		filters,
		tagsOptions,
		selectedTagsOptions,
		changeTags,
		changeParticipantsStart,
		changeParticipantsEnd,
		reset,
	} = useOrderFilter();

	const tagsNames = useAppSelector(selectOrderTagsNames);

	const namesMap = new Map<string, TNameMapValue>([
		['participants_count__gte', { name: 'Гости' }],
		['participants_count__lte', { name: 'Гости' }],
		['tags', { name: 'Теги', namesMap: tagsNames }],
		[
			'status',
			{
				name: 'Статус',
				namesMap: statusesMap,
			},
		],
	]);

	return (
		<ModalProvider>
			<FilterCard reset={reset}>
				<OrderGuestsFilter
					guestsCountStart={filters.participants_count__gte}
					guestsCountEnd={filters.participants_count__lte}
					changeParticipantsStart={changeParticipantsStart}
					changeParticipantsEnd={changeParticipantsEnd}
				/>
				<OrderTagsFilter
					tagsOptions={tagsOptions}
					selectedTagsOptions={selectedTagsOptions}
					changeTags={changeTags}
				/>
			</FilterCard>
			<FilterManager
				dateFilter={{
					start: 'dt_start__gte',
					end: 'dt_end__lte',
				}}
				filterTagsNames={namesMap}
			/>
		</ModalProvider>
	);
};
